import React from "react";
import * as XLSX from "xlsx";
import {
  applyFilterOnData,
  loanFileValidation,
  downloadExcelFile,
  generatePDFFromHtml,
  IsSectionVisible,
  renameKey,
  UpdateColumnWithConfiguration,
} from "../../../utils/helper";
import { Operators, SECTIONS } from "../../../constants/appConstants";
import PageHeader from "../../common/PageHeader";
import GridTable from "../../common/Table/Table";
import SettingScreenDialog from "../../common/SettingScreenDialog/SettingScreenDialog";
import "../../../public/css/style.less";
import {
  apiBatchRequest,
  apiBatchRequestWithoutLoader,
  apiPost,
  apiPostNoLoader,
  apiPut,
  apiRequest,
  apiRequestNoLoadder,
  CancelRequest,
  getSpsAPiRequest,
  RenewCancelToken,
  spsApiPost,
  uploadSpsAPiRequest,
  uploadSpsMetadataAPiRequest,
} from "../../../utils/api_service";
import ReportButtons from "../../../utils/ReportButtons";
import { API_URL, getCurrentEnvironment } from "../../../constants/api";
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import PageFilter from "../../common/PageFilter";
import { controlType } from "../../../constants/common";

import camelcaseKeys from "camelcase-keys";
import SearchBar from "../../common/AutoSearch/SearchBar";
import { ShowToast, toastType } from "../../../utils/toast-service";
import commonLabels from "../../../constants/messageConstants";
import { downloadExcelReportByAPI, generateString, orderKey, setDownloadingStatus } from "../../../utils/generic";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { compSetColumns, loanColumns } from "../../../constants/MockData";
import { cloneDeep } from "lodash";
import ConfirmDialog from "../../common/Dailogbox/confirmDailog";
import DownloadTemplate from "../../common/ExportImport/DownloadTemplate";
import { Autocomplete } from "@material-ui/lab";
// import PropertyBulkUpload from "./PropertyBulkUpload";
import { getSPSTokenData, setSPSToken } from "../../../constants/constants";
import { getSharePointUrl } from "../../../constants/sharepointApi";
import EditLand from "./EditLand";
import UnmappedLand from "./UnmappedLand";

const uploadColumns = [
  {
    key: "buildingName",
    name: "Building",
  },
  {
    key: "address",
    name: "Address",
  },
  {
    key: "buildingClass",
    name: "Class",
  },
  {
    key: "market",
    name: "Market",
  },
  {
    key: "subMarket",
    name: "Sub Market",
  },

  {
    key: "coStarPropId",
    name: "CoStar ID",
  },
  {
    key: "rsf",
    name: "RSF",
  },
  {
    key: "vacancy",
    name: "Vacancy%",
  },
  {
    key: "companyName",
    name: "Owner / Client",
  },
];

const columnWidths = [
  { wch: 20 },
  { wch: 20 },
  { wch: 20 },
  { wch: 20 },
  { wch: 20 },
  { wch: 20 },
  { wch: 20 },
  { wch: 20 },
];

export default class Land extends React.PureComponent {
  constructor(props) {
    super(props);
    // this.childRef = React.createRef();
    this.state = {
      openDialog: false,
      openConfirmDialog: false,
      downloadFileUrl: null,
      selectedFile: null,
      selectedFileName: null,
      selectedFileSize: null,
      breakCondition: false,
      listOfColumns: [],
      listOfCompColumns: [],
      getImportfileData: [],
      listOfDbColumn: [],
      listOfHeader: [],
      lstRequiredField: [],
      uKey: null,
      uFile: null,
      selectedValue: null,
      selectedValueId: -1,
      selectedMarketId: this.props.globalMarketId,
      reloadTable: false,
      subMarketFilteredData: [],
      subMarketData: [],
      openFilter: false,
      enableFilterButton: true,
      isInAddMode: false,
      landData: [],
      responseBuildingData: [],
      initialSummaryData: [],
      configuration: [],
      buildingMasterData: [],
      companyMasterDetails: [],
      getSubMarketMaster: [],
      selectedEditRowId: -1,
      detailView: false,
      ViewTitle: undefined,
      actionType: undefined,
      getBuildingMaster: [],
      getMarketMaster: [],
      searchInput: "",
      filterSelectedData: [],
      userConfiguration: [],
      openSlidingPanel: false,
      dbColumnList: [],
      rowsPerPage: 20,
      listOfColumns: [],

      selectedBuilding: [],
      propertyOfNonInterest: [],
      responsePropertyOfNonInterest: [],
      headerData: {
        selectAll: false,
      },
      searchInputPopup: "",
      isConfirmPopupOpen: false,
      confirmationMessage: "",
    };
  }
  onRestoreToDefault = (config) => {
    let param = config;
    apiPost({
      url: API_URL.Master.addUserConfiguration,
      params: { restoreDefault: 1 },
      postBody: param,
    })
      .then(({ data: response }) => {
        if (response.success === true) {
          this.setState({
            reloadTable: !this.state.reloadTable,
            openSlidingPanel: false,
          });
          // this.forceUpdate();
          this.getUserConfigurationBySectionId();
          ShowToast(commonLabels.settingRestored, toastType.SUCCESS, 5000, 500);
          this.getRequiredData(this.state.selectedMarketId);
        } else {
          ShowToast(commonLabels.settingNotRestored, toastType.error, 5000, 500);
        }
      })
      .catch(() => {
        ShowToast(commonLabels.somethingWrong, toastType.error, 5000, 500);
      });
  };

  onSettingChange = (config, pageSize) => {
    let param = [];
    if (config.length > 0) {
      param = config.filter((m) => {
        if (pageSize != 0) m.rowPerPage = pageSize;
        return m;
      });
    } else {
      param = this.state.userConfiguration.filter((m) => {
        if (m.dataFormat == "MultiText") {
          {
            m.minTag = 1;
            m.tagCount = true;
          }
          m.tagCount = true;
        }
        if (
          m.dataFormat == "Number" ||
          m.dataFormat == "Latitude" ||
          m.dataFormat == "Longitude" ||
          m.dataFormat == "Decimal"
        ) {
          m.headcellClass = "headcell-number-text";
        }
        if (
          m.sectionId == 268 &&
          m.isVisible == true &&
          m.key == "propertyName"
        ) {
          m.renderComponent = "renderActionColumn";
          // this.setState({
          if (pageSize != 0) m.rowPerPage = pageSize;
          //pageSize = m.rowPerPage;
          //reloadTable:!this.state.reloadTable,
          //});
          return m;
        }
      });
    }
    // this.setState(
    //   {
    //     selectedConfigData: config,
    // 	openSlidingPanel:false,
    //      },
    // );
    apiPost({
      url: API_URL.Master.addUserConfiguration,
      params: {},
      postBody: param,
    })
      .then(({ data: response }) => {
        if (response.success === true) {
          this.setState({
            // userConfiguration: camelcaseKeys(response.data),
            // rowsPerPage: response.data[0].rowPerPage,
            reloadTable: !this.state.reloadTable,
            openSlidingPanel: false,
          });
          // this.forceUpdate();
          this.getUserConfigurationBySectionId();
          ShowToast(commonLabels.settingUpdated, toastType.SUCCESS, 5000, 500);
          this.getRequiredData(this.state.selectedMarketId);
        } else {
          ShowToast(commonLabels.settingNotUpdated, toastType.error, 5000, 500);
        }
      })
      .catch(() => {
        ShowToast(commonLabels.somethingWrong, toastType.error, 5000, 500);
      });
  };
  componentDidMount() {
    RenewCancelToken();
    this.getRequiredData(this.state.selectedMarketId);

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.globalMarketId !== this.state.selectedMarketId) {
      this.getRequiredData(nextProps.globalMarketId);
      this.setState({
        selectedMarketId: nextProps.globalMarketId, selectedValue: null,
        selectedValueId: -1,
      });
    }
  }

  componentWillUnmount() {
    CancelRequest();
  }

  getUserConfigurationBySectionId = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Master.GetUserConfigurations,
        key: "userConfiguration",
        params: { sectionId: 268 },
        fromCache: true,
        duration: 60,
        clearCache: true,
      },
    ])
      .then((userConfiguration) => {
        this._asyncRequest = null;
        if (userConfiguration.userConfiguration.success == true) {
          this.setState({
            userConfiguration:
              camelcaseKeys(userConfiguration.userConfiguration.data).sort(
                (a, b) => (a.attributeSortOrder > b.attributeSortOrder ? 1 : -1)
              ) || [],
            rowsPerPage: userConfiguration.userConfiguration.data[2].rowPerPage,
            //reloadRequired:true,
            reloadTable: !this.state.reloadTable,
            listOfColumns: userConfiguration.userConfiguration.data.filter(
              (m) => {
                if (m.isVisible == true) return m.key;
              }
            ),
          });
          this.forceUpdate();
          //this.child.setRowsPerPage(this.state.rowsPerPage);
          // this.childRef.current.handleChangeRowsPerPage(this.state.rowsPerPage);
        } else {
          ShowToast(
            userConfiguration.userConfiguration.message,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  apiRequestWithoutLoadder() {
    //apiRequestNoLoadder({
    //  url: API_URL.Master.getMarketMaster,
    //  key: "getMarketMaster",
    //  params: { businessLineId: 1, marketId: selectedMarketId },
    //  fromCache: true,
    //  duration: 60,
    //}).then((getMarketMaster) => {
    //  this._asyncRequest = null;
    //  if (getMarketMaster.success == true) {
    //    this.setState({
    //      getMarketMaster: camelcaseKeys(getMarketMaster.data) || [],
    //    });
    //    this.forceUpdate();
    //  } else {
    //    ShowToast("Error", toastType.ERROR, 5000, 500, "Server error");
    //  }
    //});

    apiRequestNoLoadder({
      url: API_URL.Master.getMarketSubmarket,
      key: "getMarketSubmarket",
      params: { businessLineId: 1, marketId: selectedMarketId },
      //fromCache: true,
      //duration: 60,
    }).then((getMarketSubmarket) => {
      this._asyncRequest = null;
      if (getMarketSubmarket.market.success == true) {
        this.setState({
          getMarketMaster: camelcaseKeys(getMarketSubmarket.market.data) || [],
          getSubMarketMaster: camelcaseKeys(getMarketSubmarket.submarket.data) || [],
          subMarketData: camelcaseKeys(getMarketSubmarket.submarket.data) || [],
        });
        this.forceUpdate();
      } else {
        ShowToast("Error", toastType.ERROR, 5000, 500, "Server error");
      }
    });

    //apiRequestNoLoadder({
    //  url: API_URL.Master.getSubMarketMaster,
    //  key: "getSubMarketMaster",
    //  params: { businessLineId: 1 },
    //  fromCache: true,
    //  duration: 60,
    //  clearCache: true
    //}).then((getSubMarketMaster) => {
    //  this._asyncRequest = null;
    //  if (getSubMarketMaster.success == true) {
    //    this.setState({
    //      getSubMarketMaster: camelcaseKeys(getSubMarketMaster.data) || [],
    //      subMarketData: camelcaseKeys(getSubMarketMaster.data) || [],
    //    });
    //    this.forceUpdate();
    //  } else {
    //    ShowToast("Error", toastType.ERROR, 5000, 500, "Server error");
    //  }
    //});




    apiRequestNoLoadder({
      url: API_URL.Master.getMasterLoanPurpose,
      key: "getBuildingMaster",
      params: { businessLineId: 1 },
      fromCache: true,
      duration: 60,
    }).then((getBuildingMaster) => {
      this._asyncRequest = null;
      if (getBuildingMaster.success == true) {
        this.setState({
          getBuildingMaster: camelcaseKeys(getBuildingMaster.data) || [],
        });
        this.forceUpdate();
      } else {
        ShowToast("Error", toastType.ERROR, 5000, 500, "Server error");
      }
    });
  }


  getRequiredData = (selectedMarketId) => {
    if (selectedMarketId != "") {
      this._asyncRequest = apiBatchRequest([
        {
          url: API_URL.IndustrialLand.IndustrialLandData,
          key: "landData",
          params: { marketId: selectedMarketId },
        },


        {
          url: API_URL.Master.GetUserConfigurations,
          key: "userConfiguration",
          params: { sectionId: 268 },
          fromCache: true,
          duration: 60,
        },
        {
          url: API_URL.Master.getMarketSubmarket,
          key: "getMarketSubmarket",
          params: { businessLineId: 1, marketId: selectedMarketId },
          //fromCache: true,
          //duration: 60,
        }
      ])
        .then((landData) => {
          this._asyncRequest = null;
          if (landData.landData.success == true) {

            this.setState(
              {
                landData:
                  camelcaseKeys(landData.landData.data) ||
                  [],
                responseBuildingData: _.cloneDeep(
                  camelcaseKeys(landData.landData.data) ||
                  []
                ),
                initialSummaryData: _.cloneDeep(
                  camelcaseKeys(landData.landData.data) ||
                  []
                ),
                configuration:
                  camelcaseKeys(
                    landData.landData.configuration
                  ) || [],

                getMarketMaster: camelcaseKeys(landData.getMarketSubmarket.market.data) || [],
                getSubMarketMaster: camelcaseKeys(landData.getMarketSubmarket.submarket.data) || [],
                subMarketData: camelcaseKeys(landData.getMarketSubmarket.submarket.data) || [],

                userConfiguration: camelcaseKeys(
                  landData.userConfiguration.data != null
                    ? landData.userConfiguration.data
                    : JSON.parse(
                      window.sessionStorage.getItem("userConfigurations")
                    )
                ),
                listOfColumns:
                  landData.userConfiguration.data.filter((m) => {
                    if (m.isVisible == true) return m.key;
                  }),
                rowsPerPage:
                  landData.userConfiguration.data[2].rowPerPage,
              },
              () => {
                this.forceUpdate();
              }
            );
            //this.forceUpdate();
          } else {
            ShowToast(
              landData.landData.message,
              toastType.error,
              5000,
              500
            );
          }
        })
        .catch(() => {
          this._asyncRequest = null;
        });
    }
  };

  renderActionColumn = (cellInfo) => {
    return (
      <>
        <Tooltip title="View">
          <a
            className="default-text"
            aria-label={"refreshData"}
            size="small"
            onClick={() => {
              this.setState({
                isInAddMode: false,
              });
              this.onRowClick(cellInfo);
            }}
          >
            <span className="default-text span-link">
              {cellInfo.propertyName ? cellInfo.propertyName : "---"}
            </span>
          </a>
        </Tooltip>
      </>
    );
  };
  onRowClick = (data) => {
    this.setState({
      detailView: true,
      selectedEditRowId: data.landId,
      ViewTitle: "Edit",
      actionType: "Edit",
    });
  };
  // onFilterChange = (selectedData) => {
  //   const { landData } = this.state;
  //     const filteredData = applyFilterOnData([...landData], selectedData);
  //     this.setState({ landData: filteredData, selectedData: selectedData},
  //       () => { this.forceUpdate(); });
  //  }
  onFilterChange = (selectedData) => {
    if (selectedData.length > 0) {
      let data = [];
      data.push(selectedData);

      this.setState({
        filterSelectedData: data,
      });
    }
    if (selectedData.length > 0) {
      this.filterData(this.state.responseBuildingData, selectedData);
    } else {
      this.filterData(this.state.responseBuildingData, selectedData);
    }
  };

  filterData(landData, selectedData) {
    const filteredData = applyFilterOnData(
      [...landData],
      selectedData
    );
    this.setState(
      {
        landData: filteredData,
        selectedData: selectedData,
        reloadTable: !this.state.reloadTable,
      }
      //   () => {
      //     this.forceUpdate();
      //   }
    );
  }
  onBackClick = () => {
    this.setState({ detailView: false, selectedEditRowId: -1 });
    //this.reloadData();
  };

  onCancelClickAfterPopupAdd = () => {
    this.reloadPropertyCompanyData();
  };

  onPopupBackClick = () => {
    this.setState({ openaddform: false });
  };

  enableFilter = () => {
    let openFilter = this.state.openFilter;
    this.setState({ openFilter: !openFilter });
  };

  handlePrintClick = () => {
    this.setState(
      {
        printPage: true,
      },
      window.print()
    );
  };

  handleChange = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch();
    });
  };

  handlePopupChange = (event) => {
    this.setState({ searchInputPopup: event.target.value }, () => {
      this.globalSearchPopup();
    });
  };

  globalSearch = () => {
    let { searchInput, landData } = this.state;
    let searchData = this.state.responseBuildingData;
    let filteredData = searchData.filter((value) => {
      return (
        (this.handleCheck("landId") && value.landId
          ? value.landId
            .toString()
            .toLowerCase()
            .includes(searchInput.toLowerCase())
          : false) ||
        (this.handleCheck("propertyName") && value.propertyName
          ? value.propertyName
            .toString()
            .toLowerCase()
            .includes(searchInput.toLowerCase())
          : false) ||
        (this.handleCheck("propertyAddress") && value.propertyAddress
          ? value.propertyAddress
            .toString()
            .toLowerCase()
            .includes(searchInput.toLowerCase())
          : false)
      );
      // }
    });
    this.setState({ landData: filteredData });
    this.resetFilters();
  };


  onAddNewClick = () => {
    this.setState({
      isInAddMode: true,
      detailView: true,
      ViewTitle: "Add",
      actionType: "Add",
    });
  };


  onUnmappedLoanDetailsClick = () => {
    this.setState({
      openaddform: true,
      selectedBuilding: [],
      searchInputPopup: "",
    });
  };


  handleTableHeaderEditChange = (value, fieldName) => {
    const { headerData, propertyOfNonInterest } = this.state;
    const selectProperty = propertyOfNonInterest.map((x) => {
      x.isStreamTracked = true;
      return x;
    });
    headerData[fieldName] = value;

    this.setState(
      {
        headerData,
        selectedBuilding: value ? selectProperty : [],
        reload: !this.state.reload,
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  confirmSave = () => {
    if (this.state.selectedBuilding.length > 1) {
      this.setState({
        isConfirmPopupOpen: true,
        confirmationMessage:
          "Are you sure, you want to update '" +
          this.state.selectedBuilding.length +
          "' Properties?",
      });
    } else {
      if (this.state.selectedBuilding.length == 0) {
        ShowToast("Please select any property", toastType.ERROR, 5000, 500);
      } else {
        this.setState({
          isConfirmPopupOpen: true,
          confirmationMessage:
            "Are you sure, you want to update '" +
            this.state.selectedBuilding.length +
            "' Property?",
        });
      }
    }
  };

  onChangeKeepMarketStats = (e) => {
    if (e.target.checked) {
      this.state.selectedBuilding.map((x) => {
        x.keepMarketStats = true;
        return x;
      });
    } else {
      this.state.selectedBuilding.map((x) => {
        x.keepMarketStats = false;
        return x;
      });
    }
  };

  onInputChange = (filter, value) => {
    const params = {
      businessLineId: 1,
      searchText: value,
    };
    if (filter.key == 'compSetName') {
      apiRequestNoLoadder({
        url: API_URL.Master.getBuildingMaster,
        params,
      })
        .then(({ data: getBuildingMaster }) => {
          this.setState(
            {
              getBuildingMaster: camelcaseKeys(getBuildingMaster) || [],
            },
            () => {
              this.forceUpdate();
            }
          );
        })
        .catch((reason) => {
          this._asyncRequest = null;
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        });
    }
    else {
      apiRequestNoLoadder({
        url: API_URL.Master.buildingOwnerMasterDetails,
        params,
      })
        .then(({ data: companyMasterDetails }) => {
          this.setState(
            {
              companyMasterDetails: camelcaseKeys(companyMasterDetails) || [],
            },
            () => {
              this.forceUpdate();
            }
          );
        })
        .catch((reason) => {
          this._asyncRequest = null;
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        });
    }

  };

  onBuildingInputChange = (filter, value) => {
    const params = {
      businessLineId: 1,
      searchText: value,
    };
    apiRequestNoLoadder({
      url: API_URL.Master.getBuildingMaster,
      params,
    })
      .then(({ data: getBuildingMaster }) => {
        this.setState(
          {
            getBuildingMaster: camelcaseKeys(getBuildingMaster) || [],
          },
          () => {
            this.forceUpdate();
          }
        );
      })
      .catch((reason) => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          "Server error"
        );
      });
  };


  reloadPropertyCompanyData = () => {
    this._asyncRequest = apiBatchRequest([
      //     {
      // url: API_URL.Master.companyMasterDetails,
      // key: "companyMasterDetails",
      // params: { businessLineId: 1 },
      // fromCache: true,
      // duration: 60,
      // clearCache:true
      //     },
      //  {
      //    url: API_URL.Master.getBuildingMaster,
      //    key: "getBuildingMaster",
      //    params: { businessLineId: 1, marketId: this.state.selectedMarketId },
      //    fromCache: true,
      //    duration: 60,
      //    clearCache: true,
      //  },
    ]).then((companyMasterDetails) => {
      this._asyncRequest = null;
      if (companyMasterDetails.getBuildingMaster.success == true) {
        this.setState({
          // companyMasterDetails:
          //   camelcaseKeys(companyMasterDetails.companyMasterDetails.data) || [],
          //  getBuildingMaster:
          //    camelcaseKeys(companyMasterDetails.getBuildingMaster.data) || [],
          //    companyMasterDetails: [],
        });
        this.forceUpdate();
      } else {
        ShowToast("Error", toastType.ERROR, 5000, 500, "Server error");
      }
    });
  };
  reloadData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.IndustrialLand.IndustrialLandData,
        key: "landData",
        params: { marketId: this.state.selectedMarketId },
        // fromCache: true,
        // duration: 60,
        // clearCache:true
      },
    ])
      .then((landData) => {
        this._asyncRequest = null;
        if (landData.landData.success == true) {


          this.setState(
            {
              landData:
                camelcaseKeys(landData.landData.data) ||
                [],
              reloadTable: !this.state.reloadTable,
              responseBuildingData: _.cloneDeep(
                camelcaseKeys(landData.landData.data) ||
                []
              ),
              configuration:
                camelcaseKeys(
                  landData.landData.configuration
                ) || [],

              detailView: false,
              selectedEditRowId: -1,
              companyMasterDetails: [],
            },
            () => {
              this.forceUpdate();
            }
          );
          this.reloadPropertyCompanyData();
        } else {
          ShowToast(
            landData.landData.message,
            toastType.ERROR,
            5000,
            500
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  exportPDF = () => {
    downloadExcelReportByAPI(
      API_URL.SSRSExport.PropertyLoan,
      "BuildingLoansExport.pdf",
      this.state.selectedData,
      this.state.selectedMarketId,
      "application/pdf",
      "propertyLoan"
    );
  };

  downloadReport = () => {
    downloadExcelReportByAPI(
      API_URL.SSRSExport.PropertyLoan,
      "BuildingLoansExport.xls",
      this.state.selectedData,
      this.state.selectedMarketId,
      "application/vnd.ms-excel",
      "propertyLoan"
    );
  };

  resetFilters = () => {
    this.setState({
      filterSelectedData: null,
      //  getSubMarketMaster:[],
    }, () => { this.forceUpdate() });
  };
  handleClickOpen = () => {
    this.setState({
      openSlidingPanel: true,
    });
  };

  handleClose = () => {
    this.setState({
      openSlidingPanel: false,
    });
  };
  handleCheck(val) {
    return this.state.listOfColumns.some((item) => item.key === val);
  }
  onCancel = () => {
    this.setState({
      openDialog: false,
    });
  };
  enableDownload = () => {
    this.setState({
      openDialog: true,
    });
  };
  downloadTemplate = () => {
    //downloadExcelFile('src//components//Dashboard//PropertyOwnersExport.xlsx','MarketStats_ImportTemplate');
    downloadExcelFile(
      "public//ImportTemplate//Loan_BulkImport_Office.xlsx",
      "Loan_BulkImport_Office"
    );
  };
  importFile = () => {
    this.setState({ isUpload: true, openDialog: false });
  };
  onFileChange = (event) => {
    // Update the state
    this.setState({
      selectedFile: event.target.files[0],
      selectedFileName: event.target.files[0].name,
      selectedFileSize: event.target.files[0].size,
    });
    this.getImportFileDetails();
  };
  getImportFileDetails = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.ImportExport.getImportfileData,
        key: "getImportfileData",
        params: { sectionId: 258 },
        fromCache: true,
        duration: 60,
      },
    ])
      .then((getImportfileData) => {
        this._asyncRequest = null;
        if (getImportfileData.getImportfileData.success == true) {
          let temp = [];
          let dbColumn = [];
          let requiredColumn = [];
          getImportfileData.getImportfileData.data
            .sort((a, b) => (a.UIColumn > b.UIColumn ? 1 : -1))
            .filter((m) => {
              if (m.IsVisible == 1) {
                temp.push(m.UIColumn);
                dbColumn.push(m.DBColumn);
              }
              if (m.IsRequired == 1) {
                requiredColumn.push(m.DBColumn);
              }
            });
          // let importData= camelcaseKeys(getImportfileData.getImportfileData.data.filter((m)=>m.IsVisible == false )).sort(
          //   (a, b) => (a.uiColumn > b.uiColumn ? 1 : -1)
          // ) || [];
          this.setState(
            {
              getImportfileData:
                camelcaseKeys(getImportfileData.getImportfileData.data).sort(
                  (a, b) => (a.uiColumn > b.uiColumn ? 1 : -1)
                ) || [],

              listOfCompColumns: temp.sort(),
              listOfDbColumn: dbColumn,
              lstRequiredField: requiredColumn.sort(),
            },
            () => {
              this.forceUpdate();
            }
          );
        } else {
          ShowToast(
            "Something Went Wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };
  onFileUpload = () => {
    if (
      this.state.selectedFile == null ||
      this.state.selectedFile == undefined
    ) {
      ShowToast("Please select a file before upload.", toastType.ERROR, 5000);
    } else {
      const uploadingKey = generateString(6);
      // Create an object of formData
      setDownloadingStatus(
        uploadingKey,
        this.state.selectedFileName,
        "processing",
        "",
        "Processing import file"
      );
      const formData = new FormData();
      if (typeof FileReader !== "undefined") {
        const reader = new FileReader();
        if (reader.readAsBinaryString) {
          reader.onload = (e) => {
            this.processExcel(
              reader.result,
              this.state.selectedFileName,
              uploadingKey
            )

          };
          reader.readAsBinaryString(this.state.selectedFile);
        }
      }
      this.setState({ isUpload: false, openDialog: false, });
    }
  };
  isInt = (value) => {
    var er = /^-?[0-9]+$/;
    return er.test(value);
  };

  isFloat = (x) => {
    var er = /[+-]?([0-9]*[.])?[0-9]+/;
    return er.test(x);
  };

  isNumeric = (value) => {
    return /^-?\d+$/.test(value);
  };

  processExcel = (data, uploadedFileName, uploadingKey) => {
    console.log('====');
    // this.setState({ upKey: uploadingKey, upfileName: uploadedFileName });
    this.setState({ breakCondition: false });
    let errorMessage = "";
    const workbook = XLSX.read(data, {
      type: "binary",
      cellDates: true,
      cellText: false,
    });
    const firstSheet = workbook.SheetNames[0];
    const excelRows = XLSX.utils.sheet_to_row_object_array(
      workbook.Sheets[firstSheet],
      { defval: null, raw: false, dateNF: "YYYY-MM-DD" }
    );
    // if (
    //   this.state.selectedValue == null ||
    //   this.state.selectedValue == undefined ||
    //   this.state.selectedValue == ""
    // ) {
    //   this.setState({ breakCondition: true, selectedFile: null });
    //   errorMessage = "Please select market before import.";
    //   setDownloadingStatus(
    //     uploadingKey,
    //     uploadedFileName,
    //     "failed",
    //     errorMessage,
    //     "Validation Failure"
    //   );
    //   return false;
    // }
    const formattedData = excelRows.filter((m) => {
      return m;
    });
    let headers = [];
    if (formattedData.length == 0) {
      this.setState({ breakCondition: true, selectedFile: null });
      errorMessage =
        "The import file is empty. Please upload file with valid data";

      setDownloadingStatus(
        uploadingKey,
        uploadedFileName,
        "failed",
        errorMessage,
        "Validation Failure"
      );
      return;
    }

    formattedData.forEach(function (e, i) {
      // Iterate over the keys of object
      Object.keys(e).forEach(function (key) {
        // Copy the value
        var replacedKey = key.toString().trim();
        i == 0 && key != "OldComments" ? headers.push(replacedKey) : null;
        if (key !== replacedKey) {
          e[replacedKey] = e[key];
          delete e[key];
        }
      });
    });
    console.log(formattedData);
    let invalidObject = [];
    formattedData.forEach((m) => {
      if ((m.RSF == null || m.RSF == undefined) ||
        (m.StreamBuildingClass == null || m.StreamBuildingClass == undefined)
        || (m.SubMarket == null || m.SubMarket == undefined)) {
        invalidObject.push(m);
      }
    });
    console.log(headers);
    if (this.state.breakCondition == false) {
      //let market = formattedData[0]["CoStar Market"];
      this.updateHeaderColumn(headers.sort());
      this.setState({
        importedFileData: formattedData,
        invalidObject: invalidObject,
        uKey: uploadingKey,
        uFile: uploadedFileName,
        openConfirmDialog: false,
        //        importMarket: market,
        //openBulkUploadDialog:true,
      });
    }

    //console.log('import data',invalidObject);
    this.processFileImportAfterConfirm();
  };
  handleHeaderCheck(val) {
    //return this.state.listOfHeader.some((item) => item === val);
    return this.state.listOfHeader.includes(val);
  }
  onClickHandelFileImport(e) {
    if (e == true) {
      this.processFileImportAfterConfirm();
      this.setState({
        openConfirmDialog: false,
      });
    } else {
      this.setState({
        openConfirmDialog: false,
      });

      setDownloadingStatus(
        this.state.uKey,
        this.state.uFile,
        "failed",
        "",
        "Import cancelled by user"
      );
    }
  }
  processFileImportAfterConfirm = () => {
    let formattedData = this.state.importedFileData;
    let uploadingKey = this.state.uKey;
    let uploadedFileName = this.state.uFile;
    let ValidObj = [];
    let errorMessage = "";
    let isColumnMissing = false;
    console.log(this.state.listOfCompColumns);
    console.log(this.state.listOfHeader);

    let count = this.state.listOfCompColumns.length;
    let isColumnPresent = true;
    let columnNotFound = null;
    for (var i = 0; i < count; i++) {
      if (this.state.breakCondition != true && isColumnMissing != true)
        isColumnPresent = this.handleHeaderCheck(
          this.state.listOfCompColumns[i]
        );
      if (isColumnPresent == false) {
        isColumnMissing = true;
        columnNotFound =
          columnNotFound != null
            ? columnNotFound + "," + this.state.listOfCompColumns[i]
            : this.state.listOfCompColumns[i];

        errorMessage =
          "The import file does not contain columns specifiying the following data: [" +
          columnNotFound +
          "].Please re-import the file with this column included";

      }
    }
    if (isColumnMissing == true) {
      setDownloadingStatus(
        uploadingKey,
        uploadedFileName,
        "failed",
        errorMessage,
        "Validation Failure"
      );
    }

    formattedData.forEach((obj) => {
      for (const key in obj) {

        if (key === 'sf' || key === 'Yr Built' || key === '# Floors') {
          if (!this.isInt(obj[key])) {
            obj[key] = null;
          }
        }

        //if(key==='Price ($)')
        if (key === 'Price ($)' || key === '($) / Units' || key === '($) / (sf)' || key === 'Loan Amount ($)' || key === 'Appraisal ($)' || key === 'Underwritten NOI ($)' || key === 'Total Reserves ($)') {
          let isFl = this.isFloat(obj[key]);
          if (!isFl) {
            obj[key] = null;
          }
        }
        if (key === 'Cap Rate' || key === 'Rate' || key === 'LTV' || key === 'Debt Yield') {
          if (obj[key] && !isNaN(obj[key]) && obj[key] < 1) {
            obj[key] = obj[key] * 100;
          }
        }
      }
    });

    if (isColumnMissing != true) {
      formattedData.forEach((obj) => {
        if (this.state.breakCondition == false && isColumnMissing == false) {
          let message = null;
          let extraColumn = null;
          for (var i = 0; i < this.state.listOfDbColumn.length; i++) {
            let oldColName = this.state.listOfHeader[i];
            let newColName = this.getDbColumn(this.state.listOfHeader[i]);
            if (newColName == null) {
              isColumnMissing = true;
              extraColumn =
                extraColumn != null
                  ? extraColumn + "," + this.state.listOfHeader[i]
                  : this.state.listOfHeader[i];
              errorMessage =
                "There is extra column in template [" +
                extraColumn +
                "].Please remove this column and import again";
              setDownloadingStatus(
                uploadingKey,
                uploadedFileName,
                "failed",
                errorMessage,
                "Validation Failure"
              );

            }
            renameKey(obj, oldColName, newColName);
            let returnObj = loanFileValidation(
              obj[this.state.listOfDbColumn[i]],
              this.state.getImportfileData[i].dataFormat
            );

            if (returnObj === false) {
              let typeError = null;
              if (
                this.state.getImportfileData[i].dataFormat === "MoneyNumber" ||
                this.state.getImportfileData[i].dataFormat === "Percent" ||
                this.state.getImportfileData[i].dataFormat === "DecimalPercent"
              ) {
                typeError =
                  ". Expected value is Number with maximum 2 decimal digits";
              } else if (
                this.state.getImportfileData[i].dataFormat === "Number"
              ) {
                typeError = ". Expected value is Number without decimal";
              } else if (
                this.state.getImportfileData[i].dataFormat === "Date"
              ) {
                typeError = ". Expected value is 'mm/dd/yyyy'";
              }
              else if (
                this.state.getImportfileData[i].dataFormat === "Checkbox"
              ) {
                typeError = ". Expected value is 'Yes Or No'";
              }
              else {
                typeError = "";
              }
              message =
                message != null
                  ? message +
                  " ,Data type error in [" +
                  this.state.getImportfileData[i].uiColumn +
                  "]" +
                  typeError
                  : "Data type error in [" +
                  this.state.getImportfileData[i].uiColumn +
                  "]" +
                  typeError;

            }

            else {
              if (
                this.state.getImportfileData[i].dataFormat === "Checkbox"
                && obj[this.state.getImportfileData[i].attributeName] != null && obj[this.state.getImportfileData[i].attributeName] != undefined
                && (obj[this.state.getImportfileData[i].attributeName]).toLowerCase() === "yes"
              ) {
                obj[this.state.getImportfileData[i].attributeName] = "1";
              }
              else if (
                this.state.getImportfileData[i].dataFormat === "Checkbox"
                && obj[this.state.getImportfileData[i].attributeName] != null && obj[this.state.getImportfileData[i].attributeName] != undefined
                && (obj[this.state.getImportfileData[i].attributeName]).toLowerCase() === "no"
              ) {
                obj[this.state.getImportfileData[i].attributeName] = "0";
              }
              else if (
                this.state.getImportfileData[i].dataFormat === "Checkbox"
                && obj[this.state.getImportfileData[i].attributeName] != null && obj[this.state.getImportfileData[i].attributeName] != undefined
                && (
                  (obj[this.state.getImportfileData[i].attributeName]).toLowerCase() === null || (obj[this.state.getImportfileData[i].attributeName]).toLowerCase() === undefined)
              ) {
                obj[this.state.getImportfileData[i].attributeName] = null;
              }
            }

          }

          for (var i = 0; i < this.state.lstRequiredField.length; i++) {
            if (
              obj[this.state.lstRequiredField[i]] == null &&
              this.state.breakCondition == false
            ) {
              message =
                message != null
                  ? message +
                  " ,Field is required [" +
                  this.getUIColumn(this.state.lstRequiredField[i]) +
                  "]"
                  : "Field is required [" +
                  this.getUIColumn(this.state.lstRequiredField[i]) +
                  "]";
            }
          }
          obj.ValidationComments = message;

        }

      });
    }
    console.log(formattedData);
    let ValidData = formattedData.filter((m) => {
      if (m.ValidationComments == null) return m;
    });
    let invalidData = formattedData.filter((m) => {
      if (m.ValidationComments != null) return m;
    });

    invalidData.forEach((obj) => {
      for (var i = 0; i < this.state.listOfDbColumn.length; i++) {
        let oldColName = this.getDbColumn(this.state.listOfHeader[i]);
        let newColName = this.state.listOfHeader[i];
        renameKey(obj, oldColName, newColName);
      }
    });
    this.setState({
      formattedData: ValidData,
      uKey: uploadingKey,
      uFile: uploadedFileName,
      validFormattedData: ValidObj,
      invalidFormattedData: invalidData,
      invalidRecordCount: invalidData.length,
      totalRecordCount: formattedData.length,
    });
    if (this.state.breakCondition == false && isColumnMissing == false) {
      console.log(ValidData);
      //this.getSpsData(true);
      let d = new Date();
      let dformat = `${d.getMonth() + 1
        }${d.getDate()}${d.getFullYear()}_${d.getHours()}${d.getMinutes()}${d.getSeconds()}`;
      let fileName = this.state.selectedFileName.split(".")[0];
      let ext = this.state.selectedFileName.split(".")[1];
      fileName = fileName + "_" + dformat + "." + ext;
      this.saveImport(
        ValidData,
        this.state.uKey,
        this.state.uFile,
        fileName
      );
    }
    else {
      errorMessage =
        errorMessage != null
          ? errorMessage
          : "Error while processing file. Please try again";
      setDownloadingStatus(
        uploadingKey,
        uploadedFileName,
        "failed",
        errorMessage,
        "Validation Failure"
      );
    }
  };
  downloadImportFileData(importData, fileName) {
    const wb = XLSX.utils.book_new();
    let compHeader = JSON.parse(
      JSON.stringify([...this.state.listOfCompColumns])
    );
    compHeader.push("ValidationComments");
    importData.map((obj) => {
      orderKey(obj, compHeader);
    });
    let fN = fileName.split(".")[0];
    let ext = fileName.split(".")[1];
    let newFileName = fN + "_InvalidRecords." + ext;

    var data = importData;
    var wsData = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, wsData, "Validation Error");
    XLSX.writeFile(wb, newFileName);
    //this.uploadInvalidRecords(wb, newFileName);
  }
  uploadInvalidRecords(wb, newFileName) {
    var bin = XLSX.write(wb, { type: "array", bookType: "xlsx" });
    var blob = new Blob([bin], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    var file = new File([blob], newFileName, {
      lastModified: new Date().getTime(),
    });
    // console.log('downloadfile',XLSX.readFile(fileName))
    this.setState(
      {
        selectedFile: file,
        selectedFileName: newFileName,
        selectedFileSize: file.size,
      },
      this.getSpsData(false)
    );
  }
  getSpsData = (callSaveImport) => {
    let env = getCurrentEnvironment().sharePointLibrary;
    if (getSPSTokenData()) {
      this.setState({ spsData: {} });
      getSpsAPiRequest(getSharePointUrl("streamrealty", "getFolder")).then(
        (spsDataRes) => {
          //            console.log(res);
          //if (res.value !== null && res.value.length > 0 &&
          //	(res.value.find(x => x.displayName === env || x.name === env) !== undefined)) {
          //		const parentFolder = res.value.find(x => x.displayName === env || x.name === env);
          //		const folderKey = parentFolder.id;
          //		getSpsAPiRequest(
          //			getSharePointUrl(
          //		  	'streamrealty',
          //		  	'getInnerFolder',
          //		  	folderKey,
          //			'Lease'
          //			)
          //	  	).then((spsDataRes) => {
          const fileName = this.state.selectedFileName;
          const folderName = env; //this.cleanName(fileName);
          if (
            spsDataRes.value !== null &&
            spsDataRes.value.length > 0 &&
            spsDataRes.value.find(
              (x) => x.displayName === folderName || x.name === folderName
            ) !== undefined
          ) {
            const folder = spsDataRes.value.find(
              (x) => x.displayName === folderName || x.name === folderName
            );
            const driveId = folder.parentReference.driveId;
            const key = folder.id;
            this.setState({ spListkey: key });
            this.uploadFilesToSharePoint(callSaveImport);
          } else {
            if (folderName.length > 0) {
              spsApiPost({
                url: getSharePointUrl("streamrealty", "createFolder"),
                postBody: {
                  displayName: folderName,
                  columns: [
                    {
                      name: "FileType",
                      text: {},
                    },
                    {
                      name: "UserEmail",
                      text: {},
                    },
                    {
                      name: "UserEmail",
                      text: {},
                    },
                  ],
                  list: {
                    template: "documentLibrary",
                  },
                },
              }).then((data) => {
                if (data) {
                  this.getSpsData(callSaveImport);
                }
              });
            }
          }
          //});
          //}
        }
      );
    } else {
      apiRequest({ url: API_URL.powerBi.AcquireSPToken }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
          this.getSpsData(callSaveImport);
        }
      });
    }
  };

  uploadFilesToSharePoint(callSaveImport) {
    //        this.state.filesToBeUploaded.forEach(x => {
    let d = new Date();
    let dformat = `${d.getMonth() + 1
      }${d.getDate()}${d.getFullYear()}_${d.getHours()}${d.getMinutes()}${d.getSeconds()}`;
    let fileName = this.state.selectedFileName.split(".")[0];
    let ext = this.state.selectedFileName.split(".")[1];
    fileName = fileName + "_" + dformat + "." + ext;
    spsApiPost({
      url: getSharePointUrl(
        "streamrealty",
        "uploadFileSession",
        this.state.spListkey,
        fileName,
        "LeaseComps"
        //              x.category + '_Document_' + this.cleanName(getSectionAttributeValueByKey(this.state.getBuildingDetails, 'coStarPropId')) + '.pdf'
      ),
      postBody: {
        fileSize: this.state.selectedFileSize, //x.file.size,
        item: {
          "@microsoft.graph.conflictBehavior": "replace",
        },
      },
    }).then((data) => {
      if (data) {
        uploadSpsAPiRequest(
          data.data.uploadUrl,
          this.state.selectedFile,
          true
        ).then((data) => {
          if (data) {
            ShowToast("File uploaded successfully.", toastType.SUCCESS);
            this.setState({
              selectedFile: null,
              downloadFileUrl: data["@content.downloadUrl"],
            });
            //console.log(this.state.downloadFileUrl);
            if (
              this.state.breakCondition == false &&
              this.state.downloadFileUrl != null
            ) {
              this.saveImport(
                callSaveImport && this.state.formattedData,
                this.state.uKey,
                this.state.uFile,
                fileName
              );
            }
            //                  this.getList(data.name,
            //                    (((store.getState() || {}).auth || {}).account || {}).username || '');

            //this.updateMetaData(data.id, (((store.getState() || {}).auth || {}).account || {}).username || '', 'LeaseComps');
          } else {
            let errorMessage =
              "The import file could not be uploaded to the server.";
            setDownloadingStatus(
              this.state.uKey,
              this.state.uFile,
              "failed",
              errorMessage,
              "Processing Failure"
            );
          }

          //                this.props.onViewChange();
        });
      }
    });
    //        });
  }

  getList = (fileName, emailId) => {
    getSpsAPiRequest(
      getSharePointUrl("streamrealty", "getSps", this.state.spListkey)
    ).then((spsDataRes) => {
      if (spsDataRes) {
        const { value } = spsDataRes;
        for (let i = 0; i < value.length; i++) {
          if (fileName === value[i].name) {
            this.updateMetaData(value[i].listItem.id, emailId);
            break;
          }
        }
      }
    });
  };

  updateMetaData = (itemid, emailId = "", category) => {
    const metadata = {
      FileType: category,
      UserEmail: emailId,
    };
    uploadSpsMetadataAPiRequest(
      getSharePointUrl(
        "streamrealty",
        "uploadMetadata",
        this.state.spListkey,
        itemid
      ),
      metadata
    ).then(() => {
      // this.setState({ filesToUpload: [], selectedFile: [] });
      // this.getSpsData();
    });
  };

  getBase64Content = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      //          console.log('Error: ', error);
    };
  };

  viewFileData = async (obj, title) => {
    let url = "";
    if (obj.uploadToSp) {
      const { filesToBeUploaded, spsData } = this.state;
      const file = (filesToBeUploaded || []).find(
        (x) => x.category === obj.category
      );
      if (file && file.file) {
        this.getBase64Content(file.file, (result) => {
          //              console.log(result);
          url = result;
          this.showFile(url, title);
        });
      } else if (
        spsData &&
        spsData[obj.category] &&
        spsData[obj.category].length > 0
      ) {
        const spFile = _.orderBy(
          spsData[obj.category].filter((x) => x.name === title) || [],
          ["createdDateTime"],
          ["desc"]
        );
        if (spFile && spFile[0]) {
          this.showFile(
            await this.getSpBlob(spFile[0]["@microsoft.graph.downloadUrl"]),
            title,
            true
          );

          // this.generateShareLinkAndShow(spFile);
        } else {
          ShowToast("File not found!", toastType.INFO, 2000, 2000);
        }
      } else {
        ShowToast("File not found!", toastType.INFO, 2000, 2000);
      }
    } else {
      url = getSectionAttributeValueByKey(
        this.state.getBuildingDetails,
        obj.contentKey
      );
      this.showFile(url, title);
    }
  };

  getSpBlob = (url) => {
    return new Promise(function (resolve, reject) {
      fetch(url)
        .then((response) => response.blob())
        .then(function (blob) {
          const dataUrl = URL.createObjectURL(blob);
          return resolve(dataUrl);
        })
        .catch(() => {
          return resolve("");
        });
    });
  };

  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  showFile = (url, title, isSpsFile = false) => {
    const contentType = "application/pdf";
    let blobUrl;
    if (isSpsFile === false) {
      const blob = this.b64toBlob(
        url.replace("data:application/pdf;base64,", ""),
        contentType
      );
      blobUrl = URL.createObjectURL(blob);
    } else {
      blobUrl = url;
    }
    this.setState({
      openaddform: true,
      addformtitle: title,
      addNewformComponent: (
        <div style={{ width: "800px", height: "530px", overflow: "hidden" }}>
          {/* <iframe src={url} width="700" height="700"></iframe> */}
          {/* <embed src={`data:application/pdf;base64,${url}`} type="application/pdf" width="100%"></embed> */}
          <iframe
            id="iframe"
            onLoad={(ev) => {
              const x = document.getElementById("iframe");
              (
                ((x.contentWindow || {}).document.getElementsByTagName(
                  "embed"
                ) || [])[0] || {}
              ).style.height = "500px";
            }}
            src={blobUrl}
            style={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
              display: "block",
            }}
            frameBorder="0"
            allowFullScreen={true}
          ></iframe>
        </div>
      ),
    });
  };

  saveImport = (formattedData, uploadingKey, uploadedFileName, spsFileName) => {
    formattedData[formattedData.length] = this.state.downloadFileUrl;
    formattedData[formattedData.length] = spsFileName;
    apiPostNoLoader({
      url: API_URL.ImportExport.InsertBulkLoans,
      params: {

        marketId: -1,
        invalidRecordCount: this.state.invalidRecordCount,
      },
      postBody: formattedData,
    })
      .then(({ data: response }) => {
        if (response.success === true) {
          this.setState({
            selectedFile: null,
            fileData: [],
            userFileData: [],
            importMarket: null,
          });
          let importedData = [];
          importedData = response.data;

          if (this.state.invalidFormattedData.length > 0) {
            this.state.invalidFormattedData.forEach((m) => {
              if (m != undefined) {

                importedData.push(m);
              }
            });

          }
          importedData.forEach((m) => {
            if (m != undefined) {
              if (m["Keep Market Stats"] == "1" || m["Keep Market Stats"] == 1)
                m["Keep Market Stats"] = "Yes";
              if (m["Keep Market Stats"] == "0" || m["Keep Market Stats"] == 0)
                m["Keep Market Stats"] = "No";
              if (m["Properties Of Interest"] == "1" || m["Properties Of Interest"] == 1)
                m["Properties Of Interest"] = "Yes";
              if (m["Properties Of Interest"] == "0" || m["Properties Of Interest"] == 0)
                m["Properties Of Interest"] = "No";

              if (m["Leasing"] == "1" || m["Leasing"] == 1)
                m["Leasing"] = "Yes";
              if (m["Leasing"] == "0" || m["Leasing"] == 0)
                m["Leasing"] = "No";
              if (m["Management"] == "1" || m["Management"] == 1)
                m["Management"] = "Yes";
              if (m["Management"] == "0" || m["Management"] == 0)
                m["Management"] = "No";
            }

          })
          let validCount = this.state.totalRecordCount - importedData.length;
          let message =
            "Total Records : " +
            this.state.totalRecordCount +
            " \nInvalid Records : " +
            importedData.length +
            " \nValid Records : " +
            validCount;
          setDownloadingStatus(
            uploadingKey,
            uploadedFileName,
            "completed",
            message,
            "Import Complete"
          );
          importedData.length > 0
            ? this.downloadImportFileData(importedData, uploadedFileName)
            : null;
          this.reloadData();
        } else {
          setDownloadingStatus(
            uploadingKey,
            uploadedFileName,
            "failed",
            response.message,
            "Import Failed"
          );
        }
      })
      .catch(() => {
        setDownloadingStatus(
          uploadingKey,
          uploadedFileName,
          "failed",
          "",
          "Import Failed"
        );
      });
  };
  handleRequiredFieldCheck(val) {
    //return this.state.listOfHeader.some((item) => item === val);
    return this.state.lstRequiredField.includes(val);
  }

  getDbColumn(val) {
    let dbColumn = this.state.getImportfileData.find((x) => x.uiColumn == val);
    let dbColumnName =
      dbColumn != undefined && dbColumn != null ? dbColumn.dbColumn : null;
    // dbColumnName == null ? this.setState({breakCondition : true}) : null;
    //return this.state.listOfHeader.some((item) => item === val);
    return dbColumnName;
  }
  getUIColumn = (val) => {
    return this.state.getImportfileData.find((x) => x.dbColumn == val).uiColumn;
    //return this.state.listOfHeader.some((item) => item === val);
  };

  updateHeaderColumn = (headers) => {
    this.setState({
      listOfHeader: headers.sort(),
    });
  };

  render() {
    const {
      landData,
      buildingMasterData,

      companyMasterDetails,

      getSubMarketMaster,
      getBuildingMaster,
      getMarketMaster,
      openFilter,
      enableFilterButton,
      searchInput,
      searchInputPopup,
      userConfiguration,
      openSlidingPanel,
      listOfColumns,
      isConfirmPopupOpen,
      reloadTable,

    } = this.state;

    let pageSize = 0;
    const filterConfig = [
      {
        multiple: false,
        type: controlType.DropDown,
        minTag: 1,
        source: getMarketMaster,
        key: "market",
        placeholder: "",
        title: "Market",
      },
      {
        multiple: false,
        type: controlType.DropDown,
        minTag: 1,
        source: getSubMarketMaster,
        key: "subMarket",
        placeholder: "",
        title: "Submarket",
      },
    ];
    let userConfig = userConfiguration.filter((m) => {
      if (m.sectionId == 268 && m.isVisible == true) {
        if (m.dataFormat == "MultiText") {
          {
            m.minTag = 1;
            m.tagCount = true;
          }
          m.tagCount = true;
        }
        if (
          m.dataFormat == "Number" ||
          m.dataFormat == "Latitude" ||
          m.dataFormat == "Longitude" ||
          m.dataFormat == "Decimal" ||
          m.dataFormat == "MoneyNumber" ||
          m.dataFormat == "MoneyDecimal"
        ) {
          m.headcellClass = "headcell-number-text";
        }
        if (m.key == "propertyName") {
          m.renderComponent = "renderActionColumn";
          // this.setState({
          pageSize = m.rowPerPage;
          //reloadTable:!this.state.reloadTable,
          //});
          return m;
        }
        return m;
      }
      //this.refs.gridTable.setRowsPerPage(pageSize);
    });
    userConfig.sort((a, b) =>
      a.attributeSortOrder > b.attributeSortOrder ? 1 : -1
    );
    const dbColumnList = userConfiguration.filter((m) => {
      if (m.sectionId == 268 && m.attributeSortOrder != -1 && !m.renderComponent)
        return m; //
    });
    dbColumnList.sort((a, b) =>
      a.attributeSortOrder > b.attributeSortOrder ? 1 : -1
    );

    landData.forEach((item, index) => {
      item.serial = index + 1;
    });
    return (
      <>

        {this.state.detailView ? (
          <>
            <EditLand
              globalMarketId={this.props.globalMarketId}
              selectedBuildingId={this.state.selectedEditRowId}
              onBackClick={this.onBackClick}
              ViewTitle={this.state.ViewTitle}
              actionType={this.state.actionType}
              isInAddMode={this.state.isInAddMode}
              reloadData={this.reloadData}
              getSubMarketMaster={getSubMarketMaster}
              getMarketMaster={getMarketMaster}
              //  landData={this.state.initialSummaryData}
              companyMasterDetails={companyMasterDetails}
              buildingMasterData={buildingMasterData}
              // isPropertyOfInterest={false}
              onCancelClickAfterPopupAdd={this.onCancelClickAfterPopupAdd}
            />
          </>
        ) : (
          <>
            <div className="row no-print">
              <div className="col-md-4 col-lg-4">
                <PageHeader title="Industrial Land"></PageHeader>
              </div>
              <div>
                {dbColumnList.length > 0 && (
                  <SettingScreenDialog
                    filterSetting={JSON.parse(
                      JSON.stringify([...dbColumnList])
                    )}
                    onRestoreToDefault={this.onRestoreToDefault}
                    onApplySetting={this.onSettingChange}
                    openSlidingPanel={openSlidingPanel}
                    handleClose={this.handleClose}
                  />
                )}
              </div>

              <div className="col-md-5 col-lg-5">
                <SearchBar
                  size="large"
                  name="searchInput"
                  value={searchInput || ""}
                  onChange={this.handleChange}
                  label="Search"
                  placeholder="Search Industrial Land Name and Address."
                ></SearchBar>
              </div>

              <div className="col-md-3 col-lg-3">
                <ReportButtons
                  resetPage={[]}
                  openFilter={this.state.openFilter}
                  enableFilter={this.enableFilter}
                  handleSubmit={[]}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  exportPDF={this.exportPDF}
                  data={landData}
                  columnWidths={columnWidths}
                  exportExcel={this.exportExcel}
                  uploadColumns={uploadColumns}
                  fileName={"Report.xlsx"}
                  downloadExcelReport={this.downloadReport}
                  enableFilterButton={this.state.enableFilterButton}
                  ParentSection={SECTIONS.Property}
                  ChildSectionForDownload={SECTIONS.Property_Download}
                  ChildSectionForPrint={false} //{SECTIONS.Property_Print}
                  ChildSectionForSettings={false} // {SECTIONS.Property_Settings}
                />
              </div>
            </div>
            {/* <Divider className="divider-bg" orientation="vertical" flexItem /> */}
            {this.state.openDialog == true && (
              <Dialog open={this.state.openDialog} maxWidth="lg">
                <AppBar
                  style={{ position: "relative", backgroundColor: "#064473" }}
                >
                  <Toolbar>
                    <Typography
                      variant="subtitle1"
                      className="app-header-white"
                      style={{
                        marginLeft: "-11px",
                        flex: "1",
                        color: "#FFFFF",
                        marginTop: "-2px",
                      }}
                    >
                      Manage Data
                    </Typography>
                    <IconButton
                      edge="start"
                      color="inherit"
                      style={{ marginTop: "-18px", marginRight: "-24px" }}
                      onClick={() => {
                        this.setState({
                          openDialog: false,
                        });
                      }}
                      aria-label="close"
                    >
                      <IoMdCloseCircleOutline />
                    </IconButton>
                  </Toolbar>
                </AppBar>
                <div>
                  <DownloadTemplate
                    importData={true}
                    downloadTemplate={this.downloadTemplate}
                    importFile={this.importFile}
                    enableClear={this.enableClear}
                    onCancel={this.onCancel}
                    exportData={this.exportData}
                    hideExportClearButton={true}
                    showRefreshButton={false}
                    templateMessage={"Bulk Import Land details.Click"}
                  />
                </div>
              </Dialog>
            )}
            {(this.state.openConfirmDialog == true) && (
              <ConfirmDialog
                IsOpen={
                  this.state.openConfirmDialog
                }
                Message={
                  "You are updating Properties of Market [" +
                  this.state.selectedValue +
                  "]. \n\nDo you want to continue?"
                }
                OnHandelClick={(isValid) => {
                  if (isValid) {
                    this.onClickHandelFileImport(isValid);
                  } else {
                    this.onClickHandelFileImport(isValid);
                  }
                }}
                AgreeText="Accept"
                DisAgreeText="Cancel"
              ></ConfirmDialog>
            )}
            {this.state.isUpload == true && (
              <Dialog open={this.state.isUpload} maxWidth="lg">
                <AppBar
                  style={{
                    position: "relative",
                    backgroundColor: "#064473",
                    height: "38px",
                  }}
                >
                  <div className="row">
                    <div
                      className="col-md-6 col-lg-6"
                      style={{ marginTop: "13px" }}
                    >
                      <span> Upload File</span>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <IconButton
                        style={{
                          float: "right",
                          marginTop: "-6px",
                          marginRight: "-8px",
                        }}
                        edge="start"
                        color="inherit"
                        onClick={() => {
                          this.setState({
                            isUpload: false,
                          });

                        }}
                        aria-label="close"
                      >
                        <IoMdCloseCircleOutline />
                      </IconButton>
                    </div>
                  </div>
                </AppBar>
                <div style={{ padding: "8px" }}>
                  {/* <div>
                      Import File template :{" "}
                      <span className="span-mandatory">*</span>
                    </div>  */}

                  {/* <Autocomplete
                      size="small"
                      multiple={filterConfig[0].isMultiple}
                      underlineStyle={{ display: "none" }}
                      limitTags={1}
                      options={(this.state.getMarketMaster || []).map(
                        (option) => option[filterConfig[0].key]
                      )}
                      autoHighlight
                      value={this.state.selectedValue}
                      key={"dropDown_filter_lease_import"}
                      id={"dropDown_filter_lease_import"}
                      onChange={(event, value) => {
                        this.setState({
                          selectedValue: value,
                          selectedValueId: this.state.getMarketMaster.find(
                            (m) => m.market == value
                          ).marketId,
                        });
                      }}
                      renderInput={(params) => (
                        <Box
                          sx={{ display: "flex", alignItems: "center" }}
                          className="filter-label"
                        >
                          <label htmlFor="filled-hidden-label-small">
                            Market <span className="span-mandatory">*</span>
                          </label>
                          <TextField
                            {...params}
                            fullWidth
                            className="autosearc-text"
                            hiddenLabel
                            variant="outlined"
                            margin="normal"
                            placeholder={this.props.placeholder}
                          />
                        </Box>
                      )}
                    /> */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      paddingBottom: "5px !important",
                    }}
                    className="filter-label"
                  >
                    <label htmlFor="filled-hidden-label-small">
                      Import File
                    </label>
                  </Box>
                  <input
                    type="file"
                    style={{ padding: "24px", backgroundColor: "lightgray" }}
                    onChange={this.onFileChange}
                  />
                </div>
                <div style={{}}>
                  <button
                    className="import-button"
                    onClick={this.onFileUpload}
                  >
                    Upload
                  </button>
                </div>
              </Dialog>
            )}
            {this.state.openaddform == true && (
              <Dialog open={this.state.openaddform} maxWidth="lg">
                <AppBar
                  style={{ position: "relative", backgroundColor: "#064473" }}
                >
                  <Toolbar className="custom-toolbar">
                    <Typography
                      variant="subtitle1"
                      className="app-header-white"
                      style={{ marginTop: "15px", flex: "1", color: "#FFFFF" }}
                    >
                      {"Unmapped Land Details"}
                    </Typography>
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={() => {
                        this.setState({
                          openaddform: false,
                        });
                        this.reloadData();
                      }}
                      aria-label="close"
                      style={{ padding: "0px" }}
                    >
                      <IoMdCloseCircleOutline />
                    </IconButton>
                  </Toolbar>
                </AppBar>
                <div className="row">
                  <div className="col-sm-2 col-md-3 col-lg-3"></div>
                  <div className="col-sm-4 col-md-4 col-lg-4">

                  </div>
                  <div className="col-sm-2 col-md-2 col-lg-2 end-sm"></div>

                </div>
                <div className="row">
                  <div className="col-sm-12 col-lg-12">
                    <UnmappedLand />
                  </div>
                </div>
              </Dialog>
            )}


            {landData && listOfColumns && (
              <div className="row" style={{ marginTop: "0px" }}>
                <div className="col-md-12 col-lg-12">
                  <PageFilter
                    onInputChange={this.onInputChange}
                    resetFilters={this.resetFilters}
                    autoFilter={true}
                    openAppliedFilterPane={true}
                    filterSelectedData={this.state.filterSelectedData}
                    filterApplied={true}
                    filterAlwaysVisible={openFilter}
                    openFilter={true}
                    onFilterChanged={this.onFilterChange}
                    filterConfig={[
                      {
                        multiple: true,
                        type: controlType.DropDown,
                        source: getSubMarketMaster,
                        key: "subMarket",
                        placeholder: "",
                        title: "Submarket",
                        isVisible: this.handleCheck("subMarket"),
                      },
                      {
                        multiple: false,
                        type: controlType.TextBox,
                        key: "lender",
                        placeholder: "",
                        title: "Lender",
                        isVisible: this.handleCheck("lender"),
                        operator: [
                          Operators.In
                        ],
                      },
                      {
                        multiple: false,
                        type: controlType.TextBox,
                        key: "ownerOrBorrower",
                        placeholder: "",
                        title: "Owner/Borrower",
                        isVisible: this.handleCheck("ownerOrBorrower"),
                        operator: [
                          Operators.In
                        ],
                      },
                      {
                        multiple: true,
                        type: controlType.DateRangePicker,
                        key: "maturityDate",
                        placeholder: "",
                        title: "Land Maturity Date",
                        isVisible: this.handleCheck("maturityDate"),
                        operator: [
                          Operators.GreaterThanEqualsTo,
                          Operators.LessThanEqualsTo,
                        ],
                      },




                    ]}
                    defaultSelectedData={[]}
                    selectedData={[]}
                    gridColumn={4}
                  ></PageFilter>
                </div>
              </div>
            )}

            {landData && userConfig.length > 0 && (
              <div className="row" style={{ marginTop: "0px" }}>
                <div className="col-sm-12 col-lg-12">
                  <GridTable
                    validationMessage={[]}
                    rowCount={50
                      //this.state.rowsPerPage > 0 ? this.state.rowsPerPage : 20
                    }
                    config={userConfig}
                    columns={UpdateColumnWithConfiguration(
                      userConfig,
                      this.state.configuration,
                      []
                    )}
                    reload={this.state.reloadTable}
                    data={landData}
                    renderActionColumn={this.renderActionColumn}
                    AddNewRecord={{
                      action: this.onAddNewClick,
                      title: "Add Industrial Land",
                      visible: IsSectionVisible(
                        SECTIONS.Property,
                        SECTIONS.Property_Listing,
                        SECTIONS.ADD_EDIT
                      ),
                    }}
                  // additionalAction={{
                  //   action: this.enableDownload,
                  //   title: "Bulk Import",
                  //   visible: IsSectionVisible(
                  //     SECTIONS.Property,
                  //     SECTIONS.Property_Listing,
                  //     SECTIONS.ADD_EDIT
                  //   ),
                  // }}
                  // ConvertToPOI={{
                  //   action: this.onUnmappedLoanDetailsClick,
                  //   title: "Show Unmapped loan details",
                  //   visible: IsSectionVisible(
                  //     SECTIONS.Property,
                  //     SECTIONS.Property_Listing,
                  //     SECTIONS.ADD_EDIT
                  //   ),
                  // }}

                  ></GridTable>
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  }
}
